/* ============================================================
   Caché Perfume · Sugerencias del buscador (FUN-003)
   ------------------------------------------------------------
   El buscador de la página de búsqueda y el de cada colección
   (.srch__form) no sugerían nada al escribir. Con 2 letras o más
   se muestra una lista debajo: colecciones arriba, productos con
   foto, marca y precio (ver el orden en ordenar()) y "See all
   results" al pie, que envía el form.

   Los productos salen de la búsqueda de Shopify en JSON
   (templates/search.sugerencias.liquid), el mismo motor que la
   página de resultados; las colecciones, de /search/suggest.json.
   El suggest.json dejaba productos afuera: con "hugo boss" nunca
   traía el Boss # 6 Tonic.

   Teclado: ↓/↑ recorren la lista, Enter abre la opción marcada (si
   no hay ninguna, busca normal) y Esc cierra. Es un combobox ARIA.
   ============================================================ */
(function () {
  'use strict';

  var MIN = 2;          // ← letras mínimas para sugerir
  var ESPERA = 220;     // ← ms desde la última tecla hasta pedir
  var PRODUCTOS = 6;    // ← cuántos productos se muestran
  var n = 0;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function dinero(p) {
    var v = parseFloat(p);
    return isNaN(v) ? '' : '$' + v.toFixed(2);
  }
  function foto(prod) {
    var u = prod.image || '';
    if (!u || /[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=120';
  }

  /* Orden de las sugerencias, por tramos (dentro de cada uno se respeta el orden de Shopify):
     1 · la marca + nombre contiene lo escrito como FRASE ("hugo boss boss" → Hugo Boss Boss # 6 Tonic);
     2 · contiene TODAS las palabras, en cualquier orden (como BUS-001 en la página de resultados);
     3 · el resto.
     En cada tramo, primero las disponibles (el criterio de CAG-007): un agotado buscado por
     su nombre sale arriba, pero no le gana a lo disponible cuando la búsqueda es general. */
  function normal(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  function ordenar(q, prods) {
    var palabras = normal(q).split(/[^a-z0-9]+/).filter(Boolean);
    if (!palabras.length) return prods;
    var frase = ' ' + palabras.join(' ');
    var tramos = [[], [], [], [], [], []];
    prods.forEach(function (p) {
      // Solo letras y números, con espacios: "Boss # 6" y "boss 6" quedan iguales
      var texto = ' ' + normal(p.title + ' ' + p.vendor).split(/[^a-z0-9]+/).filter(Boolean).join(' ');
      var tramo = texto.indexOf(frase) !== -1 ? 0
        : palabras.every(function (w) { return texto.indexOf(w) !== -1; }) ? 2 : 4;
      tramos[tramo + (p.available === false ? 1 : 0)].push(p);
    });
    return [].concat.apply([], tramos);
  }

  function montar(form) {
    var input = form.querySelector('.srch__input');
    if (!input || form.dataset.sug === '1' || !window.fetch) return;
    form.dataset.sug = '1';

    var id = 'sug-' + (++n);
    var panel = document.createElement('div');
    panel.className = 'sug';
    panel.id = id;
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-label', 'Suggestions');
    panel.hidden = true;
    form.appendChild(panel);

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', id);
    input.setAttribute('aria-expanded', 'false');

    var timer = null, control = null, activa = -1, ultima = '';

    function opciones() { return Array.prototype.slice.call(panel.querySelectorAll('[role="option"]')); }
    function marcar(i) {
      var ops = opciones();
      ops.forEach(function (o, k) { o.classList.toggle('is-activa', k === i); o.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      activa = i;
      if (i >= 0 && ops[i]) { input.setAttribute('aria-activedescendant', ops[i].id); ops[i].scrollIntoView({ block: 'nearest' }); }
      else input.removeAttribute('aria-activedescendant');
    }
    function abrir() { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); form.classList.add('has-sug'); }
    function cerrar() {
      panel.hidden = true; input.setAttribute('aria-expanded', 'false'); form.classList.remove('has-sug'); marcar(-1);
    }

    function pintar(q, datos) {
      var prods = ordenar(q, datos.productos).slice(0, PRODUCTOS);
      var cols = datos.colecciones.slice(0, 3);
      var k = 0, html = '';

      if (cols.length) {
        html += '<div class="sug__cols">' + cols.map(function (c) {
          return '<a class="sug__col" role="option" id="' + id + '-' + (k++) + '" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
        }).join('') + '</div>';
      }
      if (prods.length) {
        html += '<ul class="sug__list" role="presentation">' + prods.map(function (p) {
          var img = foto(p);
          return '<li role="presentation"><a class="sug__item" role="option" id="' + id + '-' + (k++) + '" href="' + esc(p.url) + '">' +
            '<span class="sug__img">' + (img ? '<img src="' + esc(img) + '" alt="" width="60" height="60">' : '') + '</span>' +
            '<span class="sug__txt"><span class="sug__brand">' + esc(p.vendor) + '</span>' +
            '<span class="sug__name">' + esc(p.title) + '</span></span>' +
            '<span class="sug__price">' + (p.available === false ? '<span class="sug__out">Sold out</span>' : esc(dinero(p.price))) + '</span>' +
            '</a></li>';
        }).join('') + '</ul>';
      }
      if (!prods.length && !cols.length) {
        html += '<p class="sug__empty">No suggestions for &ldquo;' + esc(q) + '&rdquo;</p>';
      }
      html += '<button type="submit" class="sug__all" role="option" id="' + id + '-' + (k++) + '">See all results for &ldquo;' + esc(q) + '&rdquo; <span aria-hidden="true">&rarr;</span></button>';

      panel.innerHTML = html;
      marcar(-1);
      abrir();
    }

    function pedir() {
      var q = input.value.trim();
      if (q.length < MIN) { ultima = ''; cerrar(); return; }
      if (q === ultima && !panel.hidden) return;
      ultima = q;
      if (control) control.abort();
      control = window.AbortController ? new AbortController() : null;
      var opciones = { signal: control ? control.signal : undefined, headers: { Accept: 'application/json' } };
      var json = function (r) { if (!r.ok) throw r; return r.json(); };
      form.classList.add('is-sugiriendo');
      Promise.all([
        fetch('/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last&type=product&view=sugerencias', opciones).then(json),
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=collection&resources%5Blimit%5D=3', opciones)
          .then(json)
          .then(function (d) { return (d.resources && d.resources.results && d.resources.results.collections) || []; })
          .catch(function (e) { if (e && e.name === 'AbortError') throw e; return []; })   // sin colecciones, igual se sugiere
      ])
        .then(function (r) { return { productos: r[0] || [], colecciones: r[1] }; })
        .then(function (datos) { if (input.value.trim() === q) pintar(q, datos); })
        .catch(function (e) { if (!e || e.name !== 'AbortError') cerrar(); })
        .then(function () { form.classList.remove('is-sugiriendo'); });
    }

    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(pedir, ESPERA); });
    input.addEventListener('focus', function () { if (input.value.trim().length >= MIN && panel.innerHTML) abrir(); });

    input.addEventListener('keydown', function (e) {
      var ops = opciones();
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (panel.hidden) { if (ops.length) abrir(); else return; }
        e.preventDefault();
        // -1 es "de vuelta en el texto": de ahí ↓ va a la primera y ↑ a la última
        var sig = activa + (e.key === 'ArrowDown' ? 1 : -1);
        if (sig < -1) sig = ops.length - 1;
        if (sig >= ops.length) sig = -1;
        marcar(sig);
      } else if (e.key === 'Enter' && !panel.hidden && activa >= 0 && ops[activa]) {
        e.preventDefault();
        ops[activa].click();
      } else if (e.key === 'Escape' && !panel.hidden) {
        e.preventDefault();
        cerrar();
      }
    });

    // Al tocar fuera del buscador se cierra (las opciones son enlaces: navegan solas)
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) cerrar(); });
    form.addEventListener('focusout', function (e) { if (e.relatedTarget && !form.contains(e.relatedTarget)) cerrar(); });
  }

  function montarTodos() {
    Array.prototype.forEach.call(document.querySelectorAll('form.srch__form'), montar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', montarTodos);
  else montarTodos();
  document.addEventListener('shopify:section:load', montarTodos);
})();
